type SosButtonProps = {
  disabled?: boolean;
  isSending?: boolean;
  onPress: () => void;
};

export function SosButton({ disabled = false, isSending = false, onPress }: SosButtonProps) {
  return (
    <div className="sos-zone">
      <div className={`radar-field ${isSending ? 'activated' : ''}`} aria-hidden="true">
        <span />
        <span />
        <span />
      </div>

      <button className={`sos-button ${isSending ? 'pressed' : ''}`} type="button" disabled={disabled} onClick={onPress}>
        <span className="sos-glow" aria-hidden="true" />
        <span className="sos-text">SOS</span>
        <span className="sos-subtext">{isSending ? 'Sending' : 'Tap only in emergency'}</span>
      </button>
    </div>
  );
}
